// extracted by mini-css-extract-plugin
module.exports = {"content":"content--RkhMp","info":"info--Xemk_","image":"image--16ZTt"};